import { useTranslation } from 'next-i18next';
import { SpeedDatingComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface SpeedDatingSettingsTableInterface {
  component: SpeedDatingComponentInterface;
  onChange: (c: SpeedDatingComponentInterface) => void;
}

const SpeedDatingSettingsTable = ({ component, onChange }: SpeedDatingSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      name: t('pagebuilder:component-settings'),
      settings: [
        {
          label: t('common:name'),
          path: 'name',
          type: 'text',
          defaultValue: component.name ?? 'Speed dating',
        },
        {
          label: t('pagebuilder:matching.start-button-text'),
          path: 'startButtonText',
          type: 'text',
          defaultValue: component.startButtonText,
        },
        {
          label: t('pagebuilder:speeddating-duration-label'),
          path: 'duration',
          type: 'number',
          defaultValue: component.duration,
          inputProps: { min: 1 },
        },
        {
          label: t('pagebuilder:speeddating-disable-history'),
          path: 'disableHistory',
          type: 'boolean',
          defaultValue: component.disableHistory,
        },
        {
          label: t('pagebuilder:speeddating-disable-score'),
          path: 'disableScore',
          type: 'boolean',
          defaultValue: component.disableScore,
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />;
};
export default SpeedDatingSettingsTable;
